import _ from 'lodash'
import { uuid } from '@/lib'
import * as action from '../action-types'
import * as mutation from '../mutation-types'

export const state = {
  albums: []
}

export const getters = {
  albums: state => () =>
    state.albums,

  album: state => albumId =>
    state.albums.find(a => a.albumId === albumId),

  picture: state => (albumId, pictureId) => {
    const album = state.albums.find(a => a.albumId === albumId)
    if (!album) return null
    if (typeof pictureId === 'function') {
      return album.pictures.find(p => pictureId(p))
    }
    return album.pictures.find(p => p.pictureId === pictureId)
  }
}

export const actions = {
  [action.ALBUM_CREATE] ({commit, dispatch}, {albumId, componentType, name}) {
    albumId = albumId || uuid()
    name = name || 'Unnamed Album'
    commit(mutation.ALBUM_CREATE, {
      albumId,
      componentType,
      name,
      emit: true
    })
    dispatch(action.WINDOW_CREATE, {
      componentType,
      title: name,
      data: {albumId, contentId: albumId}
    })
  },

  [action.ALBUM_OPEN] ({dispatch, getters}, {albumId}) {
    const album = getters.album(albumId)
    if (!album) return
    dispatch(action.WINDOW_OPEN_CREATE, {
      componentType: album.componentType || 'album-window',
      title: album.name,
      contentId: albumId
    })
  },

  [action.ALBUM_DELETE] ({commit}, {windowId, albumId}) {
    commit(mutation.WINDOW_DELETE, {
      windowId,
      emit: true
    })
    commit(mutation.ALBUM_DELETE, {
      albumId,
      emit: true
    })
  },

  [action.ALBUM_META] ({commit}, {albumId, name}) {
    commit(mutation.ALBUM_META, {
      albumId,
      name,
      emit: true
    })
  },
  [action.ALBUM_PICTURE_CREATE] ({commit}, {albumId, pictureId, fileName, fileType, fileSize, image}) {
    commit(mutation.ALBUM_PICTURE_CREATE, {
      albumId,
      pictureId,
      fileName,
      fileType,
      fileSize,
      image,
      emit: true
    })
  },
  [action.ALBUM_PICTURE_CHANGE] ({getters, commit}, {albumId, pictureId, fileName, fileType, fileSize, image}) {
    const picture = getters.picture(albumId, pictureId)
    if (picture && picture.image === image) return
    commit(mutation.ALBUM_PICTURE_UPDATE, {
      albumId,
      pictureId,
      fileName,
      fileType,
      fileSize,
      image,
      emit: true
    })
  },
  [action.ALBUM_PICTURE_REMOVE] ({commit}, {albumId, pictureId}) {
    commit(mutation.ALBUM_PICTURE_DELETE, {
      albumId,
      pictureId,
      emit: true
    })
  }
}

export const mutations = {
  [mutation.ALBUM_STATE] (state, {albums, pictures}) {
    pictures = _.groupBy(pictures, 'albumId')
    state.albums = _.map(albums, album => {
      album.pictures = pictures[album.albumId] || []
      return album
    })
  },
  [mutation.ALBUM_CREATE] (state, {albumId, name}) {
    const idx = state.albums.findIndex(a => a.albumId === albumId)
    if (idx >= 0) return
    state.albums.push({albumId, name, pictures: []})
  },
  [mutation.ALBUM_DELETE] (state, {albumId}) {
    const idx = state.albums.findIndex(a => a.albumId === albumId)
    state.albums.splice(idx, 1)
  },
  [mutation.ALBUM_META] (state, {albumId, name}) {
    const album = state.albums.find(a => a.albumId === albumId)
    if (!album) return
    album.name = name || album.name
  },
  [mutation.ALBUM_PICTURE_CREATE] (state, {albumId, pictureId, fileName, fileType, fileSize, image}) {
    const album = state.albums.find(a => a.albumId === albumId)
    if (!album) return
    album.pictures.push({
      pictureId,
      fileName,
      fileType,
      fileSize,
      image
    })
  },
  [mutation.ALBUM_PICTURE_UPDATE] (state, {albumId, pictureId, fileName, fileType, fileSize, image}) {
    const album = state.albums.find(a => a.albumId === albumId)
    if (!album) return
    const picture = album.pictures.find(p => p.pictureId === pictureId)
    if (!picture) return
    picture.fileName = fileName
    picture.fileType = fileType
    picture.fileSize = fileSize
    picture.image = image
  },
  [mutation.ALBUM_PICTURE_DELETE] (state, {albumId, pictureId}) {
    const album = state.albums.find(a => a.albumId === albumId)
    if (!album) return
    const idx = album.pictures.findIndex(p => p.pictureId === pictureId)
    album.pictures.splice(idx, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/albums.js